/**------------- Used Car Drawer constants -------------**/

/*  General  */
export const USED_CAR_DRAWER_CLASS_NAME = "used-car-drawer";

/*  Horizontal Flex  */
export const USED_CAR_DRAWER_HORIZONTAL_FLEX_CLASS_NAME =
	"used-car-drawer-flex-horizontal";
export const USED_CAR_DRAWER_HORIZONTAL_FLEX_WIDTH = "60%";

/*  Vertical Flex  */
export const USED_CAR_DRAWER_VERTICAL_FLEX_CLASS_NAME =
	"used-car-drawer-flex-vertical";
export const USED_CAR_DRAWER_VERTICAL_FLEX_WIDTH = "40%";

/*  Data  */
export const USED_CAR_INFO_API_KEY = "used-car-info";
